import { Button, Grid } from "@mui/material";
import { formatMoney, formatValue } from "../Dashboard/summary/Utils";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import OpenInNew from "@mui/icons-material/OpenInNew";

const mdTheme = createTheme({
  palette: {
    primary: {
      main: "#5628D2",
    },
  },
});

export default function Popover({ properties, onClick }) {
  const imgStyle = { width: "600px", height: "200px", borderRadius: 5 };
  const address = [
    properties.formatted_street_address,
    properties.city,
    properties.state,
    properties.zip_code,
  ].join(" ");
  const key = process.env.REACT_APP_GOOGLE_STREET_KEY;
  const url = `https://maps.googleapis.com/maps/api/streetview?size=600x200&location=${address}&key=${key}`;
  return (
    <ThemeProvider theme={mdTheme}>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={3}
        justifyContent="space-between"
      >
        <Grid item xs={12}>
          <img src={url} style={imgStyle} alt="Street View" />
        </Grid>
        <Grid item xs={12}>
          <b>{properties.formatted_street_address}</b>, {properties.city},{" "}
          {properties.state} {properties.zip_code}
        </Grid>
        <Grid item textAlign="center">
          <div>{formatValue(properties.beds_count) || "--"}</div>
          <div>Beds</div>
        </Grid>
        <Grid item textAlign="center">
          <div>{formatValue(properties.baths) || "--"}</div>
          <div>Baths</div>
        </Grid>
        <Grid item textAlign="center">
          <div>{formatValue(properties.partial_baths_count) || "--"}</div>
          <div>Partial Baths</div>
        </Grid>
        <Grid item textAlign="center">
          <div>{formatValue(properties.total_area_sq_ft) || "--"}</div>
          <div>Sqft</div>
        </Grid>
        <Grid item textAlign="center">
          <div>{properties.year_built || "--"}</div>
          <div>Year Built</div>
        </Grid>
        <Grid item textAlign="center">
          <div>{formatValue(properties.stories) || "--"}</div>
          <div>Stories</div>
        </Grid>
        <Grid item textAlign="center">
          <div>{formatMoney(Math.round(properties.avg_std)) || "--"}</div>
          <div>Avg Std</div>
        </Grid>
        <Grid item textAlign="center">
          <div>{formatMoney(Math.round(properties.best_std)) || "--"}</div>
          <div>Best Std</div>
        </Grid>
        <Grid item style={{ width: "100%" }}>
          <Button
            style={{ width: "100%" }}
            variant="outlined"
            xs={12}
            onClick={() =>
              onClick(
                properties.formatted_street_address,
                properties.city,
                properties.state,
                properties.zip_code
              )
            }
          >
            Open
            <OpenInNew style={{ fontSize: "16px", marginLeft: "0.35em" }} />
          </Button>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
